import React from 'react';
import { Amplify } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import WorkflowList from './pages/WorkflowList';
import WorkflowEditor from './pages/WorkflowEditor';
import ExecutionsList from './pages/ExecutionsList';
import ExecutionDetails from './pages/ExecutionDetails';
import Login from './pages/Login';
import FacebookCallback from './pages/FacebookCallback';

// Configure Amplify
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
            userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
            identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID || '',
            signUpVerificationMethod: 'code',
        },
    },
});

// Protected route component
function RequireAuth({ children }: { children: React.ReactElement }) {
    const location = useLocation();
    const { route } = useAuthenticator((context) => [context.route]);
    
    if (route !== 'authenticated') {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    
    return children;
}

function App() {
    const { route, user, signOut } = useAuthenticator((context) => [
        context.route,
        context.user,
        context.signOut
    ]);
    
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/facebook-callback" element={<FacebookCallback />} />
                <Route
                    path="/*"
                    element={
                        <RequireAuth>
                            <Layout signOut={signOut} user={user}>
                                <Routes>
                                    <Route path="/" element={<Dashboard />} />
                                    <Route path="/workflows" element={<WorkflowList />} />
                                    <Route path="/workflows/new" element={<WorkflowEditor />} />
                                    <Route path="/workflows/:id" element={<WorkflowEditor />} />
                                    <Route path="/executions" element={<ExecutionsList />} />
                                    <Route path="/executions/:id" element={<ExecutionDetails />} />
                                </Routes>
                            </Layout>
                        </RequireAuth>
                    }
                />
            </Routes>
        </ThemeProvider>
    );
}

export default App;
